import {FloatingSignUp} from "components/commons";
import CalculatorInfoSection from "../CalculatorInfoSection";
import Calculator from "./Calculator";
import React from "react";

const SwpPageContent = () => (
  <>
    <Calculator />
    <FloatingSignUp />
    <CalculatorInfoSection slug="swp" />
  </>
);

export default SwpPageContent;
